import script from "./lives.vue?vue&type=script&setup=true&lang=js"
export * from "./lives.vue?vue&type=script&setup=true&lang=js"

import "./lives.vue?vue&type=style&index=0&id=995ea0d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-995ea0d2"]])

export default __exports__